import { useGetAssessmentQuery, useGetCourseQuery } from "./store/hooks";
import { uuidToIntId } from "../../../helpers/uuid";
import TextSkeleton from "../../../utility/TextSkeleton";

export function CourseName({ courseId }: { courseId: string }) {
	const { data, isLoading } = useGetCourseQuery(courseId);
	return isLoading ? <TextSkeleton /> : (data?.name ?? courseId);
}

export function AssessmentName({ assessmentId }: { assessmentId: string }) {
	const { data, isLoading } = useGetAssessmentQuery(uuidToIntId(assessmentId));
	return isLoading ? <TextSkeleton /> : (data?.name ?? uuidToIntId(assessmentId));
}
